import editorRefs from '../../editJournal/editorRefs';
import { DocumentTypes } from '../../../../../constants/templateDictionaries';

// set editorRefs dictionary on initial load
export const getEditorRef = (templateType) => {
  // check if it fails for APPLIED_PHYSICS
  if (templateType) {
    const template = DocumentTypes[templateType].id;
    return editorRefs[template];
  }
  return null;
};

// REMOVE/UPDATE THIS WHILE CLEANING UP
export const getUpdatedEditorRef = (...payload) => {
  const [editorRefsDict, ref, paragraphType, publicationType] = [...payload];
  const editorRefsCopy = { ...editorRefsDict };
  if (publicationType === 'journal') {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, val] of Object.entries(editorRefs)) {
      if (val.type === paragraphType) {
        editorRefsCopy[key].editorRef = ref;
        return editorRefsCopy;
      }
    }
  }
  return editorRefsCopy;
};
